module.exports = __webpack_public_path__ + "static/1-1-ff49c3247fff3883cd146fb8cfb73493.png";